<template lang="pug">
div
  el-form
    el-form-item(label="用户画像" style="background: #fff;")
      .els.up(@click="() => showUserProfile = true" :class="{ 'no_data': chooseUpDataStr == '不限' }") {{ chooseUpDataStr }}
      .fr
        i.el-icon-arrow-right
  el-dialog(
    title="用户画像" width="790px" height="500px" :append-to-body="true" :close-on-click-modal="false"
    :visible.sync="showUserProfile" custom-class="profile_pop user_profile")
    .ctn
      .top 标签选择
      div
        UserProfileObjs(v-model="profileData")
    span(slot="footer")
      .fix-btn.red(@click="changeProfile") 确定
      .fix-btn(@click="closeProfile") 取消

</template>

<script>
import UserProfileObjs from '@/views/PutOrder/components/OrderForm/UserProfileObjs'
import { jointUserPf } from '@/utils/functions'
export default {
  name: 'UserProfile',
  components: { UserProfileObjs },
  props: {
    value: Array
  },
  data () {
    return {
      showUserProfile: false,
      profileData: [],
      profileDataConfirm: []
    }
  },
  computed: {
    chooseUpDataStr () {
      let objList = this.profileDataConfirm.filter(el => el.list && el.list.length) // 有数据画像的物体列表
      if (objList.length) return jointUserPf(objList, 'name')
      else return '不限'
    }
  },
  watch: {
    value (v) { // 取消展开之后 选中确定的数据状态
      this.profileData = JSON.parse(JSON.stringify(v))
    }
  },
  methods: {
    closeProfile () {
      this.showUserProfile = false
      this.profileData = JSON.parse(JSON.stringify(this.profileDataConfirm)) // 复原数据 深拷贝保存确认数据 以免数据联动影响
    },
    hasSame (list) {
      let all = list.map(el => el.list.map(el => el.code).sort().join('')).filter(el => el)
      let set = [...new Set(all)]
      return all.length > set.length
    },
    changeProfile () {
      if (this.hasSame(this.profileData)) return this.messageTip('画像数据不能重复', 2)
      this.profileDataConfirm = this.profileData

      // // 选择可能会中间有空画像，过滤重排下保存, 根据需求可以放开这里
      // let names = [ '画像A', '画像B', '画像C', '画像D', '画像E' ]
      // this.profileDataConfirm = this.profileData.filter(el => el.list.length).map((element, i) => ({ ...element, name: names[i] }))

      this.closeProfile() // closeProfile 时 profileData 又重新深拷贝了一下
      this.$emit('input', this.profileDataConfirm)
    }
  }
}
</script>

<style lang="scss" scoped>
.ctn {
  border: 1px solid #D4D4D4;
  height: 100%;
  overflow: auto;
}
.top {
  background: #F5F5F5;
  font-weight: 550;
  text-align: left;
  padding-left: 20px;
  line-height: 40px;
}
.els.up {
  float: left;
  width: calc(100% - 92px);
  padding-left: 15px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  &.no_data {
    color: #C0C4CC;
  }
  & + .fr {
    line-height: 1;
    margin-top: 7px;
    margin-right: 10px;
    color: #999;
  }
}
</style>

<style lang="scss">
.profile_pop.user_profile {
  text-align: center;
  top: 50%;
  margin-top: -260px !important;
  .el-dialog__body {
    padding: 20px;
    height: 420px;
    border-top: 1px solid #E9E9E9;
    border-bottom: 1px solid #E9E9E9;
  }
  .el-dialog__footer {
    padding: 0;
    text-align: center;
  }
}
</style>
